import Service from '@/helpers/service'

export default {

    index(params) {
        return Service().get('manage-sub-menu/index', {params});
    },
    getMenu(params) {
        return Service().get('manage-sub-menu/get-menu', {params});
    },
    show(id) {
        return Service().get('manage-sub-menu/show/'+id);
    },
    create(params) {
        return Service().post('manage-sub-menu/create', params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    update(id, params) {
        return Service().post('manage-sub-menu/update/'+id, params, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
        });
    },
    delete(id) {
        return Service().post('manage-sub-menu/delete/'+id);
    },
}